<script lang="ts">
  const WIDTH = 64;
  const HEIGHT = 64;
  const MULTIPLIER = 3; /*                              */
  const PADDING = 8;

  interface Props {
    url: string
    altText: string
  }

  let {
    url,
    altText,
  }: Props = $props();
</script>

<img
  class="ft5-upselling-image"
  width={WIDTH + 2 * PADDING}
  height={HEIGHT + 2 * PADDING}
  style={`padding: ${PADDING}px;`}
  alt={altText}
  src={`${url}?w=${MULTIPLIER * WIDTH}&h=${MULTIPLIER * HEIGHT}`}
/>

<style lang="scss">
  .ft5-upselling-image {
    object-fit: contain;
    background-color: #ffffff;
    border-radius: 12px;
    flex-shrink: 0;
    flex-grow: 0;
  }
</style>
